 // stickybar js start
 var $ = require('jquery');
 if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    $(".funddetails-wrapper-list").addClass("tab-scroll tab-scroll-awards");
}
 window.onscroll = function() {
    
    var url = document.location.href;
    var stickyLength = 0;
        stickyLength = 1.6 ;
    myFunction(stickyLength)
    };
    
  var navbar = document.getElementById("navbar");
  var sticky ="";
  if(navbar != null)  { sticky = navbar.offsetTop;}
  function myFunction(stLen) {
     if(navbar != null)  {

        if (window.pageYOffset >= (sticky/stLen)) {
            navbar.classList.add("sticky")
        } else {
            navbar.classList.remove("sticky");
        }
    }
    
  }
 
$(window).ready(function () {
  $(document).on("click", ".sec-nav-list li a", function () {
        if($(this).attr("data-url") != undefined)
        {
      var url = $(this).attr("data-url");
      var curId = url;
        $(curId.length > 0)
        {
      var eleTop = $(curId).offset().top;
      if ($('.sticky').length > 0) {
        var stickyheight=$("header").height()+$(".sticky").height()+$(".breadcrumbs").height();
       $('html, body').animate({scrollTop : eleTop-stickyheight},100);
      }
            else {
        var stickyheight=$("header").height()+$(".breadcrumbs").height();
      $('html, body').animate({scrollTop : eleTop-stickyheight},300);
      }
        }
        }
    });
  });

  // adding navbar active class start
if (window.location.href.indexOf('sustainability') == -1) {
   $(window).scroll(function() {
      var position = $(this).scrollTop();
      var headerheight=$("header").height()+$(".sticky").height()+$(".breadcrumbs").height();
      $('.tab-anchor-content').each(function() {
      var target = $(this).offset().top- headerheight-$(".sticky").height();
      var id = $(this).attr('id');
      if (position >= target) {
      $('.navbar ul li a').removeClass('active');
      $('.navbar ul li a[data-url="#' + id + '"]').addClass('active');
      }
      });
      var isSticky = $('.sec-nav').hasClass('sticky');
        if (isSticky) {
        $(".head-desk").hide();
     }
     else{
        $(".head-desk").show();
     }

  });
}
if (window.location.href.indexOf('sustainability') > -1) {
var lastScrollTop = 0;
var i = 0, j = 0;
$(window).scroll(function () {
    var position = $(this).scrollTop();
    var headerheight=$("header").height()+$(".sticky").height()+$(".breadcrumbs").height();
    $('.tab-anchor-content').each(function () {
        var target = $(this).offset().top- headerheight-$(".sticky").height();
       // var target = $(this).offset().top - 400;
        var id = $(this).attr('id');
        if (position >= target) {
            $('.navbar ul li a').removeClass('active');
            $('.navbar ul li a[data-url="#' + id + '"]').addClass('active');
            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                if (($(window).scrollTop() > $('body').height() / 2) && i<=2) {
                        if (position > lastScrollTop) {
                        $('.tab-scroll-sust .slick-next').click();
                        i=1;
                    }
                } 
                if (($(window).scrollTop() < $('body').height() / 2)) {
                        //console.log("up scrolling")
                        $('.tab-scroll-sust .slick-prev').click();
                        j=1;
                } 
            }
    }
        
    });
    lastScrollTop = position;
    var isSticky = $('.sec-nav').hasClass('sticky');
    if (isSticky) {
        $(".head-desk").hide();
    }
    else {
        $(".head-desk").show();
    }
});
}

  // adding navbar active class start

  // stickybar js end

//   tab-scroll js start

$(document).ready(function(){
    function slick_scroller(className, _speed, _slidesToShow, _slidesToScroll, _slidesToShow_ipad, _slidesToScroll_ipad, _slidesToShow_mob, _slidesToScroll_mob) {
        
    $(className).slick({
        dots: false,
        infinite: false,
        speed: _speed,
        variableWidth: true,
        slidesToShow: _slidesToShow,
        slidesToScroll: _slidesToScroll,
        arrows:true,
        responsive: [
         {
             breakpoint: 1024,
             settings: {
                 slidesToShow: _slidesToShow_ipad,
                 slidesToScroll: _slidesToScroll_ipad,
                 arrows: true
             }
         },
           {
               breakpoint: 767,
               settings: {
                   slidesToShow: _slidesToShow_mob,
                   slidesToScroll: _slidesToScroll_mob,
                   arrows: true
               }
           }, 
     ]             
      });
        $(className).on('setPosition', function (event, slick) {
            var $nextArrow = $(className).find('.slick-next');

            if (slick.currentSlide === slick.slideCount - slick.options.slidesToShow) {
                $nextArrow.hide();
            } else {
                $nextArrow.show();
            }
        });
}

    slick_scroller('.tab-scroll-equity', 300, 8, 1, 4, 1, 2, 1 );
    if (window.location.href.indexOf('institutional-investor') > -1 || window.location.href.indexOf('investor-education') > -1) {
        slick_scroller('.tab-scroll-sust', 300, 5, 1, 4, 1, 2, 1 );
    }
    else{
        slick_scroller('.tab-scroll-sust', 300, 3, 1, 4, 1, 2, 1 );
    }
   
    slick_scroller('.tab-scroll-awards', 300, 2, 1, 4, 1, 2, 1 );   
    slick_scroller('.tab-scroll-leadership', 300, 3, 1, 4, 1, 1, 1 );
    slick_scroller('.tab-scroll-about', 300, 7, 1, 4, 1, 2, 1 );  
    slick_scroller('.tab-scroll-discovery-funds', 300, 5, 1, 4, 1, 1, 1 );     
    slick_scroller('.tab-scroll-invest', 300, 4, 1, 4, 1, 1, 1);
    slick_scroller('.tab-scroll-press-releases', 300, 6, 1, 4, 1, 1, 1 ); 
    if ($(".secondary-nav").length > 0) {
        var components = [];
        setTimeout(function () {
            $('.tab-anchor-content').each(function () {
                var Title = $(this).attr('data-display');
                var Url = "#" + $(this).attr('id');
                components.push({ Title: Title, Url: Url });
            });
            $.ajax({
                url: window.location.pathname + '/GenerateNavigation',
                method: 'POST',
                data: JSON.stringify({ components: components }),
                contentType: 'application/json',
                success: function (response) {
                    if (response.length > 0) {
                        var insightsresult = response;
                        if (insightsresult != null && insightsresult != undefined) {
                            var strtindex = insightsresult.indexOf("<!-- sec nav start -->");
                            var endindex = insightsresult.indexOf("<!-- sec nav end -->");
                            var res = insightsresult.substring(strtindex, endindex);
                            $('.secondary-nav').append(res);
                            slick_scroller('.tab-scroll-about', 300, 7, 1, 4, 1, 2, 1);

                        }
                    }
                },
                error: function (xhr, status, error) {
                    // Handle error
                },
                complete: function () {
                    window.onscroll = function () {

                        var url = document.location.href;
                        var stickyLength = 0;
                        stickyLength = 1.6;
                        myFunction(stickyLength)
                    };

                    var navbar = document.getElementById("navbar");
                    var sticky = "";
                    if (navbar != null) { sticky = navbar.offsetTop; }
                    function myFunction(stLen) {
                        if (navbar != null) {

                            if (window.pageYOffset >= (sticky / stLen)) {
                                navbar.classList.add("sticky")
                            } else {
                                navbar.classList.remove("sticky");
                            }
                        }

                    }
                }
            });
        }, 500);
    }
    

});

//   tab-scroll js end

// heritage sec start
//fade in and fade out effect for company page heritage section
$(window).scroll(function () {
    var windowBottom = $(this).scrollTop() + $(this).innerHeight();
    $(".heritage--row").each(function () {
        / Check the location of each desired element /
        var objectBottom = $(this).offset().top + $(this).outerHeight();

        / If the element is completely within bounds of the window, fade it in /
        if (objectBottom < windowBottom) {
            //object comes into view (scrolling down)
            if ($(this).css("opacity") == 0) {
                $(this).fadeTo(500, 1);
            }
            $(this).find('.heritage--item--row').addClass('animate');
            $(this).find('.heritage--date span').addClass('animate');
        } else {
            //object goes out of view (scrolling up)
            if ($(this).css("opacity") == 1) {
                $(this).fadeTo(500, 0);
            }
            $(this).find('.heritage--item--row').removeClass('animate');
            $(this).find('.heritage--date span').removeClass('animate');
        }
    });
}).scroll();

// heritage sec end